import { useQuery } from "@tanstack/react-query";
import { getMerchantsFacilitiesMunicipalities } from "Infrastructure/Api/Api";
import { MS_TIME } from "Utils/TimeUtils";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import type { EntityListOfMunicipalityDto } from "Infrastructure/Api/Api";

const MUNICIPALITY_SEARCH_QUERY_KEY = "MUNICIPALITY_SEARCH";

export const municipalitySearchKeys = {
  all: [MUNICIPALITY_SEARCH_QUERY_KEY] as const,
  bySearchTerm: (searchTerm: string | undefined) => [
    ...municipalitySearchKeys.all,
    searchTerm ?? "",
  ],
};

export const useMunicipalitySearchQuery = (
  searchTerm: string | undefined,
  enabled = true,
) =>
  useQuery<EntityListOfMunicipalityDto>({
    queryKey: municipalitySearchKeys.bySearchTerm(searchTerm),
    queryFn: processResponseWithApiProblemDetails(() =>
      getMerchantsFacilitiesMunicipalities(searchTerm),
    ),
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * MS_TIME.minute,
  });
